export default "/kiban/_next/static/images/question-290fba71905554689c3d12fe30b1f9c3.png";